module.exports = __webpack_public_path__ + "prod/1.42.2/img/honging-icon.0a1ccf9f.png";